import {
  FormField,
  PasswordField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { VersionControl } from 'shared/types';
import { useRepositoryFormContext } from './RepositoryFormContext';

type SharedTokenForm = {
  sharedToken: string;
};

type Props = {
  register: UseFormRegister<SharedTokenForm>;
  errors: FieldErrors<SharedTokenForm>;
  selectedVersionControl: VersionControl | undefined;
  isEdit?: boolean;
  isNewConnection?: boolean;
};

const SharedTokenField = ({
  register,
  errors,
  selectedVersionControl,
  isEdit = false,
  isNewConnection = false,
}: Props) => {
  const { isLoading } = useRepositoryFormContext();
  if (
    !['GitHub', 'GitLab', 'AzureDevOps'].includes(selectedVersionControl || '')
  ) {
    return null;
  }

  if (isNewConnection) {
    return null;
  }

  const isRequired = !isEdit && !isNewConnection;

  return (
    <FormField
      title={isEdit ? 'Update token' : 'Access token'}
      description={
        isEdit
          ? 'This token will be used for all dbt projects. Leave empty to keep the existing tokens.'
          : 'This token will be used for all dbt projects.'
      }
      errorMessage={errors.sharedToken?.message}
      optional={isEdit}
    >
      <PasswordField
        {...register('sharedToken', {
          required: isRequired ? requiredLabel : false,
        })}
        placeholder="Token"
        fullWidth
        size="large"
        disabled={isLoading}
      />
    </FormField>
  );
};

export default SharedTokenField;
